import { createApp } from 'vue'
import Antd from 'ant-design-vue';
import App from './App';
import 'ant-design-vue/dist/antd.css';
import router from './router/router.js';
import store from './store';
import VueJsonp from 'vue-jsonp';
const app = createApp(App);

app.use(Antd)
    .use(router)
    .use(VueJsonp)
    .use(store)
    .mount('#app');
